export default {
  'accountDetails.title': 'Account Details',
  'accountDetails.noDataMessage': 'No transactions matched your search criteria.',
  'accountDetails.currentAvailableCrsSuppressed': 'Current Available (CRS Suppressed)',
  'accountDetails.currentAvailable': 'Current Available',
  'accountDetails.openingLedger': 'Opening Ledger',
  'accountDetails.closingLedger': 'Closing Ledger',
  'accountDetails.currentLedger': 'Current Ledger',
  'accountDetails.closingAvailable': 'Closing Available',
  'accountDetails.yesterdaysValue': "Yesterday's Value",
  'accountDetails.todaysPosition': "Today's Position",
  'accountDetails.investmentsFor': 'Investments',
  'accountDetails.adjustedBalance': 'Adjusted Balance'
};
